import { useState } from "react";
import { FiChevronDown, FiChevronUp } from "react-icons/fi";
import {
  checkboxData,
  checkboxDataEn,
} from "src/core/statics/filter-results/checkbox-filter-results-data";
import { useTranslation } from "react-i18next";

function CheckBoxComponent() {
  const [isOpen, setIsOpen] = useState<number[]>([]);
  const handleOpen = (value: number) => {
    let UpdatedOpen = [];
    if (isOpen.includes(value)) {
      UpdatedOpen = isOpen.filter((item) => item !== value);
      setIsOpen(UpdatedOpen);
    } else {
      UpdatedOpen = [...isOpen];
      UpdatedOpen.push(value);
      setIsOpen(UpdatedOpen);
    }
  };
  const { i18n } = useTranslation();
  const data = i18n.language === "ar" ? checkboxData[0] : checkboxDataEn[0];
  return (
    <div
      dir={i18n.language === "ar" ? "rtl" : "ltr"}
      className="flex flex-col divide-y px-3"
    >
      {data.contentsWithTitle.map((item, index) => (
        <div key={index}>
          <div
            className="flex justify-between cursor-pointer py-2.5 "
            onClick={() => handleOpen(index)}
          >
            <div className="font-arMedium text-zinc600 text-xl">
              {item.tilte}
            </div>
            {isOpen.includes(index) ? (
              <FiChevronUp size={24} className="text-zinc600" />
            ) : (
              <FiChevronDown size={24} className="text-zinc600" />
            )}
          </div>
          {isOpen.includes(index) && (
            <div key={index}>
              {" "}
              {item.contents.map((item, index) => (
                <div className="flex gap-1 py-3 pr-3" key={index}>
                  <input type="checkbox"></input>
                  <div className="font-arMedium text-sm text-start text-zinc500 w-full">
                    {item}
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      ))}
      {data.contentsNoTitle.map((item, index) => (
        <div className="flex gap-1 py-2.5 px-3" key={index}>
          <input type="checkbox"></input>
          <div className="font-arRegular text-xl text-zinc600">{item}</div>
        </div>
      ))}
    </div>
  );
}

export default CheckBoxComponent;
